/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const archiveTitle = (
	<SVG viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
		<Path stroke="#1E1E1E" strokeWidth="1.5" d="M4 19.25h9M4 15.25h16" />
		<Path
			d="M8.994 10.103H6.08L5.417 12H4l2.846-8h1.383l2.845 8H9.657l-.663-1.897zm-.457-1.28l-.994-2.857-1.006 2.857h2z"
			fill="#1E1E1E"
		/>
	</SVG>
);

export default archiveTitle;
